module.exports = __webpack_public_path__ + "img/3.8f3e7fb4.png";